import Link from 'next/link'

import { ABOUT } from 'routes/paths'
import { Typography, Button } from '~ui'

import styles from './About.module.scss'

const { Paragraph: P } = Typography

const About = () => (
  <div className={styles.about}>
    <div className={styles.content}>
      <h1 className={styles.title}>About Granted</h1>
      <P>
        We are an experience platform dedicated to creating deeper, more meaningful connections
        between artists and fans. And we care a lot about that first sentence. Like A LOT. Because
        we&apos;re just fans—like you.
      </P>
      <P>
        At Granted, you can purchase VIP packages curated by your favorite artists, bid on
        unforgettable auctions that benefit important causes, and get tickets to awesome live
        events. Look, we know we aren&apos;t the first and we know the purchase to delivery process
        can have its &lsquo;WTF&rsquo; moments. So we came together and created Granted.
      </P>
      <P>
        But here, we will always have your back to ensure you have the best experience when going
        with Granted. So what are you waiting for? Let&apos;s get your access, Granted.
      </P>

      <Link legacyBehavior href={ABOUT}>
        <a style={{ textDecoration: 'none' }}>
          <Button variant="primary">Learn More</Button>
        </a>
      </Link>
    </div>
  </div>
)

export default About
